import Products from "./products";


const hooks = {
    Products,
};

export default hooks;